(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var ListView = require('../views/list')
  , FormView = require('../views/form')
  , TourCollection = require('../collections/tour')
  , TourModel = require('../models/tour')
  , debug = require('../../../../admin/source/js/app/lib/debug')('router')

module.exports = function (serviceLocator) {
  var router = serviceLocator.router
    , collection = new TourCollection()
    , displayName = { singular: 'Tour', plural: 'Tours' }

  function getData (cb) {
    Backbone.ajax(
    { url: window.config.apiUrl + '/featured-agents'
      , type: 'GET'
      , success: function (data) {
        return cb(null, { featuredAgents: data })
      }
      , error: function (req, status, error) {
        return cb(error)
      }
    }
    )
  }

  router.route('tours(/)', 'listTours', function () {

    debug('tour url list view route triggered')
    if (!serviceLocator.allow('tour', 'read')) {
      return false
    }

    getData(function (err, data) {
      var listView = new ListView(
        { collection: collection
        , serviceLocator: serviceLocator
        , displayName: displayName
        , featuredAgents: data.featuredAgents
        })

      router.render(listView, displayName.plural)

      collection.reset([])
      collection.applyFilter(listView.filters.getSavedParams())
    })
  })

  router.route('tours/form(/)', 'newTour', function () {
    if (!serviceLocator.allow('tour', 'create')) {
      return false
    }

    debug('tour create view route triggered')

    getData(function (err, data) {
      var model = new TourModel({}, { collection: collection })
        , view = new FormView(
          { model: model, title: displayName.singular
          , featuredAgents: data.featuredAgents
          , serviceLocator: serviceLocator
          })

      view.on('save cancel', function () {
        router.navigate('tours', { trigger: true })
      })

      router.render(view, displayName.plural)
    })
  })

  router.route('tours/:id/form(/)', 'editTour', function (id) {
    if (!serviceLocator.allow('tour', 'update')) {
      return false
    }
    debug('tour edit view route triggered')

    getData(function (err, data) {
      collection.retrieve(id, function (err, model) {
        if (err) {
          router.trigger('notFound', err.message)
          return
        }

        debug('Loading form view', model)

        var view = new FormView(
          { model: model
          , title: displayName.singular
          , featuredAgents: data.featuredAgents
          , serviceLocator: serviceLocator
          })

        view.on('cancel', function () {
          router.navigate('tours', { trigger: true })
        })

        router.render(view, displayName.plural)
      })
    })
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/tour/controllers/controller.js","/components/admin/tour/controllers")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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